import {useEffect, useState} from 'react';
import AccordionWrapper from 'Components/FormComponents/AccordionWrapper'
import TextField from 'Components/FormComponents/TextField';
import SelectField from 'Components/FormComponents/SelectField';
import RadioButtons from 'Components/FormComponents/RadioButtons';
import ToggleSwitch from 'Components/FormComponents/ToggleSwitch';
import Checkboxes from 'Components/FormComponents/Checkboxes';
import SortSelect from 'Components/FormComponents/SortSelect';
import MultiRangeSlider from 'Components/FormComponents/MultiRangeFilter';
import Textarea from 'Components/FormComponents/Textarea';
import DateField from 'Components/FormComponents/DateField';

const FormField = ({fieldConfig, state, onChange, setState, searchCallback, onKeyPress, ...rest}) => {
  const {type, name, checked, defaultValue} = fieldConfig;
  const [shouldSearch, setShouldSearch] = useState(false);

  useEffect(() => {
    // Fill state with default value.
    if ((checked && type !== 'radio') || defaultValue) {
      setState((prev) => {
        return {
          ...prev,
          [name]: checked ? checked : defaultValue
        }
      })
    }
  }, []);

  useEffect(() => {
    if (shouldSearch) {
      setShouldSearch(false);
      searchCallback();
    }
  }, [state]);

  if (!type) {
    return '';
  }

  onChange = onChange && typeof onChange === 'function' ? onChange : (event) => {
    const {name, value, checked, type, dataset} = event.target;

    setState((prev) => {
      if (type === 'checkbox') {
        const {fieldName} = dataset;
        if (checked) {
          return {
            ...prev,
            [fieldName]: [...prev[fieldName] || [], value],
          };
        }

        const newArray = prev[fieldName].filter((item) => {
          if (item !== value) {
            return item
          }
          return false;
        });

        return {
          ...prev,
          [fieldName]: newArray,
        };
      }
      else if (type === 'radio') {
        if (checked) {
          return {
            ...prev,
            [name]: value,
          };
        }
      }
      else if (type === 'toggle') {
        return {
          ...prev,
          [name]: checked
        };
      }
      else if (type === 'range') {
        return {
          ...prev,
          [name]: {
            from: value.min,
            to: value.max,
          }
        }
      }
      else {
        if (event.submit) {
          setShouldSearch(true);
        }
        return {
          ...prev,
          [name]: value,
        };
      }
    });
  };

  const renderField = () => {
    const mapping = {
      'text': TextField,
      'select': SelectField,
      'radios': RadioButtons,
      'toggle': ToggleSwitch,
      'checkboxes': Checkboxes,
      'sortSelect': SortSelect,
      'range': MultiRangeSlider,
      'textarea': Textarea,
      'date': DateField,
    };
    const Component = mapping[type] ? mapping[type] : '';

    if (Component) {
      let settings = {...fieldConfig, state};

      if (settings.accordionWrapper) {
        const label = settings.label;
        settings = {
          ...settings,
          label: ''
        };

        const tooltips = [
          {
            labelID: 'Algolia.SearchPage.HousingType.Label',
            tooltipID: 'Algolia.SearchPage.HousingType.Tooltip',
          },
          {
            labelID: 'Algolia.SearchPage.languagePrerequisiteLevel.Label',
            tooltipID: 'Algolia.SearchPage.languagePrerequisiteLevel.Tooltip',
          },
          {
            labelID: 'Algolia.SearchPage.GPARequirements.Label',
            tooltipID: 'Algolia.SearchPage.GPARequirements.Tooltip',
          },
          {
            labelID: 'Algolia.SearchPage.ProgramFees.Label',
            tooltipID: 'Algolia.SearchPage.ProgramFees.Tooltip',
          },
        ];
        const findTooltips = tooltips.find((obj) => {
          return obj.labelID === label;
        });

        return (
          <AccordionWrapper label={label} tooltip={findTooltips && findTooltips.tooltipID}>
            <Component settings={settings}
                       onChange={onChange}
                       setState={setState}
                       searchCallback={searchCallback}
                       onKeyPress={onKeyPress}
                       {...rest}/>
          </AccordionWrapper>
        );
      }
      return <Component settings={settings}
                        onChange={onChange}
                        setState={setState}
                        searchCallback={searchCallback}
                        onKeyPress={onKeyPress}
                        {...rest}/>;
    }

    return '';
  };

  return (
    <>
      {renderField()}
    </>
  )
};

export default FormField;
